// reducers/authReducer.js

import { resolveUserRole } from "../../utilities/userRoleUtils";

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  refreshToken: null,
  userRole: null,
  loading: false,
  error: null,
  expiresIn: null
};

/**
 * Authentication reducer to handle login/logout actions
 */
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case 'LOGIN_SUCCESS': {
      console.log('LOGIN_SUCCESS action:', action);

      // Extract user data and tokens from the response
      const { payload } = action;
      
      // The user object should come from responseData.user if available
      const user = payload.responseData?.user || payload.user || {};
      
      // Extract token either from direct token or from responseData.access_token
      const token = payload.token || payload.responseData?.access_token || null;
      
      // Extract refresh token if available
      const refreshToken = payload.responseData?.refresh_token || null;
      
      // Extract user role — ignore Keycloak account roles like manage-account-links
      const userRole = resolveUserRole(user, payload.clientId) || null;
      
      // Extract token expiration if available
      const expiresIn = payload.responseData?.expires_in || null;
      
      return {
        ...state,
        isAuthenticated: true,
        user,
        token,
        refreshToken,
        userRole,
        expiresIn,
        loading: false,
        error: null
      };
    }
    
    case 'LOGIN_FAILURE':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        refreshToken: null,
        userRole: null,
        loading: false,
        error: action.payload
      };
    
    case 'LOGOUT':
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};

export default authReducer;
